import { render, staticRenderFns } from "./prospect.vue?vue&type=template&id=ef475f6c"
import script from "./prospect.vue?vue&type=script&lang=js"
export * from "./prospect.vue?vue&type=script&lang=js"
import style0 from "./prospect.vue?vue&type=style&index=0&id=ef475f6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports